
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buyer-consultancy",
      function () {
        return require("private-next-pages/buyer-consultancy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buyer-consultancy"])
      });
    }
  